import { Component, Watch } from "vue-property-decorator";
import baseUserContextPage from "../baseUserContextPage";
import { pagedList, sortDirection } from "@/models/pagedList";
import axios from "axios";
import { ShoppingOfferModel } from "@/models/offerModel";
import { CustomerInfoModel } from "@/models/customerModels";
import eventHub from "@/eventHub";

@Component({})
export default class Offers extends baseUserContextPage {
    isLoading: boolean = false;
    list: pagedList<ShoppingOfferModel> = new pagedList();

    fileLogo: any = null;
    imagePreview: any = null;

    showCustomerModal: boolean = false;
    showModalLogo: boolean = false;
    onlyValid: boolean = true;

    @Watch("onlyValid")
    onOnlyValidChange(newVal: boolean) {
        this.fetch();
    }

    created() {
        eventHub.$on(eventHub.events.CURRENT_CUSTOMER_CHANGED, this.fetch);
        this.loadLogo();
    }

    searchParams: any = {
        pageSize: 20,
        pageIndex: 0,
        search: null,
        orderField: "createDate",
        direction: sortDirection.ASC
    };

    loadLogo(): void {
        var self = this;

        axios
            .get<pagedList<ShoppingOfferModel>>(`/cart/offer/${self.getCurrentCustomer.id}/logo`)
            .then((res) => {
                if (res && res.data) self.imagePreview = res.data;
            })
            .catch((error) => {
                self.imagePreview = null;
            });
    }

    updateQueryParams(): void {
        var instance = this;
        instance.$router.push({
            name: "offers",
            query: instance.getQueryParams()
        });
        this.fetch();
    }
    getQueryParams(): any {
        var instance = this;
        return {
            page: instance.searchParams.pageIndex,
            search: instance.searchParams.search,
            orderField: instance.searchParams.orderField,
            direction: instance.searchParams.direction
        };
    }
    setQueryParams(params: any) {
        var instance = this;
        instance.searchParams.pageIndex = params.page;
        instance.searchParams.search = params.search;
        instance.searchParams.orderField = params.orderField;
        instance.searchParams.direction = params.direction;
    }

    pageChanged(page: number) {
        this.searchParams.pageIndex = page;
        this.updateQueryParams();
    }
    onSearch() {
        this.searchParams.pageIndex = 0;
        this.updateQueryParams();
    }
    onSelect(customer: ShoppingOfferModel) {
        this.$router.push({ path: `/offers/${customer.id}` });
    }
    onSort(field: string) {
        var instance = this;
        if (instance.searchParams.orderField != field) {
            instance.searchParams.orderField = field;
            instance.searchParams.direction = sortDirection.ASC;
        } else {
            instance.searchParams.direction = instance.searchParams.direction == sortDirection.ASC ? sortDirection.DESC : sortDirection.ASC;
        }

        instance.updateQueryParams();
        //instance.fetch();
    }
    fetch(): void {
        var instance = this;
        instance.isLoading = true;
        let params = instance.searchParams;
        params.onlyValid = this.onlyValid;
        if (instance.getCurrentCustomer) {
            let customerId = instance.getCurrentCustomer.id;
            axios
                .get<pagedList<ShoppingOfferModel>>("/cart/offer/search/" + customerId, {
                    params: params
                })
                .then((res) => {
                    instance.list = res.data ? res.data : new pagedList();
                    instance.isLoading = false;
                })
                .catch((error) => {
                    console.error(error);
                    instance.isLoading = false;
                });
        }
    }
    mounted() {
        var instance = this;
        instance.setQueryParams(instance.$route.query);
        instance.fetch();
    }

    get isCurrentCustomerSelected(): boolean {
        if (this.getCurrentCustomer == null) {
            this.list = new pagedList();
        }

        return this.getCurrentCustomer != null;
    }

    get showCustomerDescription(): boolean {
        return this.isUserB2BAdmim || this.isUserRefEmployee || this.isUserEmployee;
    }

    onSelectCustomer(customer: CustomerInfoModel) {
        var instance = this;
        instance.setCurrentCustomer(customer);
        instance.showCustomerModal = false;

        instance.fetch();
    }

    onDeleteOffer() {
        this.fetch();
    }

    handleImageUpload(e) {
        // const file = e.target.files[0];
        // this.imagePreview = URL.createObjectURL(file);

        return;

        var self = this;
        if (this.fileLogo) {
            console.log("caricato");
            // const reader = new FileReader();
            // reader.onload = () => {
            //     // Aggiorna l'URL dell'immagine
            //     self.imagePreview = reader.result;
            // };
            // reader.readAsDataURL(this.fileLogo);

            return;
        }

        console.log("NON caricato");
        return null;
    }

    salvaLogo() {
        if (!this.fileLogo) {
            this.$notify({
                title: "ATTENZIONE",
                text: `Selezionare prima il file da caricare`,
                type: "warn",
                group: "msg"
            });

            return;
        }

        var self = this;
        let formData = new FormData();

        formData.append("files", this.fileLogo);

        this.isLoading = true;
        axios
            .post<any>(`cart/offer/${self.getCurrentCustomerId}/logo`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            })
            .then((res) => {
                self.$notify({
                    title: "Operazione eseguita",
                    text: `Caricamento del logo completato con successo`,
                    type: "success",
                    group: "msg"
                });

                self.fileLogo = null;
                self.loadLogo();
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                self.isLoading = false;
            });
    }

    deleteLogo() {
        var self = this;
        self.isLoading = true;
        axios
            .delete(`/cart/offer/${self.getCurrentCustomer.id}/logo`)
            .then((res) => {
                self.showModalLogo = false;
                self.imagePreview = null;
            })
            .catch((error) => {
                self.imagePreview = null;
            })
            .finally(() => {
                self.isLoading = false;
            });
    }
}
